import { inject, PLATFORM_ID } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth.service';
import { first, iif, of, switchMap, tap } from 'rxjs';
import { isPlatformServer } from '@angular/common';

export const authGuard: CanActivateFn = (_route, _state) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const platformId = inject(PLATFORM_ID);

  if (isPlatformServer(platformId)) return of(false);

  return authService.user.pipe(
    first(),
    switchMap((user) => iif(() => !!user, of(true), authService.silentLogin().pipe(first()))),
    switchMap((loggedIn) => iif(() => loggedIn, of(true), of(router.createUrlTree(['/', 'auth', 'login'])))),
  );
};
